import React from "react";

const labels={
  demonstrated:"Demonstrated",
  needs_follow_up:"Needs follow-up",
  not_established:"Not established",
  pending_review:"Pending review"
};

export default function AssessmentEvidenceReport({report,onOpenAnswer}){
  return <section className="assessment-evidence-report" aria-label="Assessment evidence report">
    <div className="assessment-evidence-title"><h4>Assessment evidence report</h4><small>Question set v{report.question_set_version||1} · {report.summary.total} criteria</small></div>
    <p>These findings describe evidence in the submitted answers. Pending review is not a negative finding. The hiring team makes the decision.</p>
    <div className="assessment-evidence-counts">{Object.entries(labels).map(([key,label])=><span key={key}><strong>{report.summary[key]||0}</strong> {label}</span>)}</div>
    <div className="assessment-evidence-scroll"><table><thead><tr><th>Question · criterion</th><th>Finding</th><th>Evidence and rationale</th><th>Source</th></tr></thead><tbody>
      {report.questions.flatMap((question,index)=>question.criteria.map((criterion,i)=><tr key={question.id+":"+i}>
        <th scope="row"><small>Q{index+1} · {question.text}</small><b>{criterion.name}</b></th>
        <td>{labels[criterion.finding]||"Pending review"}</td>
        <td>{criterion.evidence_excerpt&&<q>{criterion.evidence_excerpt}</q>}{criterion.reason&&<span>{criterion.reason}</span>}{criterion.follow_up_question&&<em>Follow up: {criterion.follow_up_question}</em>}</td>
        <td><span>{question.review_source==="recruiter_manual"?"Recruiter review":question.review_source==="ai"?"AI draft":"Awaiting review"}</span>
          <button type="button" className="assessment-text-action" onClick={()=>onOpenAnswer(question.id,criterion.recording_second)}>View answer{criterion.recording_second!=null?" at "+Math.floor(criterion.recording_second/60)+":"+String(Math.floor(criterion.recording_second%60)).padStart(2,"0"):""}</button></td>
      </tr>))}
    </tbody></table></div>
  </section>;
}
